var React = require('react');

function IconLocation (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13","cy":"13","r":"13","fill":"#EB5757","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19 11c0 2.191-1.009 4.341-2.655 6.296C15.13 18.736 13.601 20 13 20c-.602 0-2.131-1.264-3.344-2.704C8.009 15.34 7 13.19 7 11a6 6 0 1112 0zm-8.197 5.33c.543.644 1.137 1.228 1.69 1.686.223.184.507.39.507.39s.316-.233.507-.39a13.608 13.608 0 001.69-1.687C16.637 14.621 17.5 12.781 17.5 11a4.5 4.5 0 10-9 0c0 1.781.863 3.62 2.303 5.33zM10.75 11a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25-.75a.75.75 0 110 1.5.75.75 0 010-1.5z","fill":"#fff","key":1})]);
}

IconLocation.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = IconLocation;

IconLocation.default = IconLocation;
